import * as React from "react";
import BaseModal, { BaseModalContent } from "../BaseModal";
import { Button } from "@material-ui/core";

const MissMatchDriverIdModal = (props)=>{ 
    const {handlecloseMissMatchDriverModal, isOpenMissMatchDriverIdModal} = props

    return(
        <>
            <BaseModal
             title="MisMatch Driver Id"
             align="center"
             open={isOpenMissMatchDriverIdModal}
             onClose={handlecloseMissMatchDriverModal}
                fullWidth
                className="modal-header"
            >
                <BaseModalContent>
                  <div className="d-flex justify-content-between align-items-center mt-2">
                  <h3>Driver Id does not exist...</h3>
                  </div>
                  <br />
                  <br/>

                  <Button 
                  variant="contained"
                    color="primary" 
                    onClick={handlecloseMissMatchDriverModal} 
                    style={{backgroundColor:"#20419a",color:"white", float:'right' }}>
                    Ok</Button>
                </BaseModalContent>
            </BaseModal>
        </>
    )
}

export default MissMatchDriverIdModal;
